/**
 * Paket F (Till 30.10.2026): der Satz unter „Grundlage sind … Anfos“ auf der Übersicht — wer nicht zählt, je Grund, und
 * wie viele Anfos über die Anmeldung (ohne Kennung) beim Webinar stehen. Leer, wenn es nichts zu sagen gibt.
 */
import type { AuswertungenMeta } from '../../helpers/auswertungenData';
import { formatNumber } from '../../helpers/numberUtils';

const zahl = (n: number, eins: string, viele: string): string => `${formatNumber(n, 0)} ${n === 1 ? eins : viele}`;

export function nichtGezaehltText(p: AuswertungenMeta['population']): string {
  const teile: string[] = [];
  const a = p.ausgeschlossen;
  const tage = p.regeln?.vorlaeufig_max_tage ?? 120;
  if (a && a.mitarbeiter > 0) teile.push(`${zahl(a.mitarbeiter, 'Bestellung', 'Bestellungen')} von Mitarbeiter-Adressen`);
  if (a && a.vorlaeufig_alt > 0)
    teile.push(
      `${zahl(a.vorlaeufig_alt, 'vorläufig ergänzte Anfo', 'vorläufig ergänzte Anfos')}, deren Bestellung älter als ${tage} Tage ist`,
    );
  const saetze: string[] = [];
  if (teile.length > 0) saetze.push(` Nicht gezählt: ${teile.join(' und ')}.`);
  const ohne = p.ohne_kennung ?? 0;
  if (ohne > 0)
    saetze.push(
      ` ${zahl(ohne, 'Anfo', 'Anfos')} ohne Kennung im Bestell-Link ${ohne === 1 ? 'zählt' : 'zählen'} beim Webinar, weil die Adresse vorher angemeldet war.`,
    );
  return saetze.join('');
}
